const SIGN_IN_REDIRECT_STORAGE_KEY = 'session.signInRedirectAt'
const SIGN_IN_LOOP_WINDOW_MS = 30_000

const sessionStorageOrNull = () => {
  try {
    return globalThis.sessionStorage
  } catch {
    return null
  }
}

export const piloteSignInUrl = (returnTo: string) =>
  `${import.meta.env.VITE_PILOTE_BASE_URL}/app/operation?returnTo=${encodeURIComponent(returnTo)}`

// A session carried in the URL is the one that just ended: coming back with it would shadow the
// fresh cookie the sign-in sets.
const pageToReturnTo = () => {
  const url = new URL(globalThis.location.href)
  url.searchParams.delete('session')
  return url.toString()
}

export const redirectToPiloteSignIn = () => {
  sessionStorageOrNull()?.setItem(SIGN_IN_REDIRECT_STORAGE_KEY, String(Date.now()))
  globalThis.location.assign(piloteSignInUrl(pageToReturnTo()))
}

export const cameBackFromPiloteSignInRecently = () => {
  const redirectedAt = Number(sessionStorageOrNull()?.getItem(SIGN_IN_REDIRECT_STORAGE_KEY))
  return redirectedAt > 0 && Date.now() - redirectedAt < SIGN_IN_LOOP_WINDOW_MS
}

export const forgetPiloteSignInRedirect = () => {
  sessionStorageOrNull()?.removeItem(SIGN_IN_REDIRECT_STORAGE_KEY)
}
